import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://ktjhdypxcvxioaklvrhv.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt0amhkeXB4Y3Z4aW9ha2x2cmh2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA2NzQ0ODUsImV4cCI6MjA3NjI1MDQ4NX0.bI8ghonZy1X1GC5vkAd-vPge7KSC0OvB9UAUZfetYko';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Database = {
  public: {
    Tables: {
      profiles: {
        Row: {
          id: string;
          full_name: string | null;
          email: string | null;
          avatar_url: string | null;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id: string;
          full_name?: string | null;
          email?: string | null;
          avatar_url?: string | null;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          full_name?: string | null;
          email?: string | null;
          avatar_url?: string | null;
          created_at?: string;
          updated_at?: string;
        };
      };
      projects: {
        Row: {
          id: string;
          title: string;
          description: string | null;
          status: 'Ativo' | 'Concluído' | 'Arquivado';
          priority: 'Baixa' | 'Média' | 'Alta';
          start_date: string | null;
          end_date: string | null;
          responsible: string | null;
          progress: number;
          user_id: string;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          title: string;
          description?: string | null;
          status?: 'Ativo' | 'Concluído' | 'Arquivado';
          priority?: 'Baixa' | 'Média' | 'Alta';
          start_date?: string | null;
          end_date?: string | null;
          responsible?: string | null;
          progress?: number;
          user_id: string;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          title?: string;
          description?: string | null;
          status?: 'Ativo' | 'Concluído' | 'Arquivado';
          priority?: 'Baixa' | 'Média' | 'Alta';
          start_date?: string | null;
          end_date?: string | null;
          responsible?: string | null;
          progress?: number;
          user_id?: string;
          created_at?: string;
          updated_at?: string;
        };
      };
      project_configurations: {
        Row: {
          id: string;
          project_id: string;
          database_type: string | null;
          database_host: string | null;
          database_port: string | null;
          database_name: string | null;
          database_user: string | null;
          database_password: string | null;
          github_repository: string | null;
          github_branch: string | null;
          github_token: string | null;
          admin_name: string | null;
          admin_email: string | null;
          payment_provider: string | null;
          payment_api_key: string | null;
          payment_webhook: string | null;
          tech_frontend: string | null;
          tech_backend: string | null;
          tech_deploy: string | null;
          tech_monitoring: string | null;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          project_id: string;
          database_type?: string | null;
          database_host?: string | null;
          database_port?: string | null;
          database_name?: string | null;
          database_user?: string | null;
          database_password?: string | null;
          github_repository?: string | null;
          github_branch?: string | null;
          github_token?: string | null;
          admin_name?: string | null;
          admin_email?: string | null;
          payment_provider?: string | null;
          payment_api_key?: string | null;
          payment_webhook?: string | null;
          tech_frontend?: string | null;
          tech_backend?: string | null;
          tech_deploy?: string | null;
          tech_monitoring?: string | null;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          project_id?: string;
          database_type?: string | null;
          database_host?: string | null;
          database_port?: string | null;
          database_name?: string | null;
          database_user?: string | null;
          database_password?: string | null;
          github_repository?: string | null;
          github_branch?: string | null;
          github_token?: string | null;
          admin_name?: string | null;
          admin_email?: string | null;
          payment_provider?: string | null;
          payment_api_key?: string | null;
          payment_webhook?: string | null;
          tech_frontend?: string | null;
          tech_backend?: string | null;
          tech_deploy?: string | null;
          tech_monitoring?: string | null;
          created_at?: string;
          updated_at?: string;
        };
      };
    };
  };
};